import React, {useState} from "react";
import { Link } from 'react-router-dom';

// reactstrap components
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";

import LLPushNotification from 'components/LLPushNotification.js';
import CacheRefresh from "components/CacheRefresh.jsx";

function HomeNav(props) {
  
  return (
    <>
      <CacheRefresh />        
      <div
        style={{
          backgroundImage: "url(" + require("assets/img/2.png") + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
      <ul className="nav justify-content-center">
      <li className="nav-item">
          <Link className="nav-link" to={'/liquidlove/home'}><b>Home</b></Link>
        </li>
      </ul>  
      <ul className="nav justify-content-center">
        {/*
        <li className="nav-item">
          <Link className="nav-link" to={'/liquidlove/patient'}><b>Blood request</b></Link>
        </li>
        <li className="nav-item">
          <UncontrolledDropdown nav>
            <DropdownToggle
              caret
              color="default"
              href="#pablo"
              nav
              onClick={(e) => e.preventDefault()}
            >                
                <b>Donor</b>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                to="/liquidlove/donor-consent" tag={Link}
              >
                <i className="now-ui-icons arrows-1_minimal-right mr-1"></i>
                Register
              </DropdownItem>
              <DropdownItem to="/liquidlove/verify/donor" tag={Link}>
                <i className="now-ui-icons arrows-1_minimal-right mr-1"></i>
                Update profile
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </li>
         */}
        <li className="nav-item">
          <UncontrolledDropdown nav>
            <DropdownToggle
              caret
              color="default"
              href="#pablo"
              nav
              onClick={(e) => e.preventDefault()}
            >                  
              <b>
                {props.adminName !== undefined && props.adminName !== '' ? 'Sairam! ' + props.adminName : 'Administrator'}
              </b>
            </DropdownToggle>
            <DropdownMenu>                
              <DropdownItem to="/liquidlove/login" tag={Link}>                    
                <i className="now-ui-icons objects_key-25 mr-1"></i>
                Login
              </DropdownItem>
              <DropdownItem
                to="/liquidlove/adminprofile" tag={Link}
              >
                <i className="now-ui-icons users_single-02 mr-1"></i>                    
                Update profile
              </DropdownItem>
              <DropdownItem
                to="/liquidlove/changepwd" tag={Link}
              >
                <i className="now-ui-icons ui-2_settings-90 mr-1"></i>                    
                Change password
              </DropdownItem>
              <DropdownItem divider/>
              <DropdownItem
                to="/liquidlove/requests" tag={Link}
              >                    
                <i className="now-ui-icons design_bullet-list-67 mr-1"></i>
                View requests
              </DropdownItem>                  
              <DropdownItem
                to="/liquidlove/donors" tag={Link}
              >
                <i className="now-ui-icons design_bullet-list-67 mr-1"></i>
                View donors
              </DropdownItem>              
              <DropdownItem divider />
              <DropdownItem
                to="/liquidlove/register-admin" tag={Link}
              >
                <i className="now-ui-icons users_circle-08 mr-1"></i>
                Register Admin
              </DropdownItem>
              <DropdownItem
                to="/liquidlove/resetpwd" tag={Link}
              >
                <i className="now-ui-icons ui-1_simple-delete mr-1"></i>
                Reset Password
              </DropdownItem>
              <DropdownItem
                to="/liquidlove/import/donors" tag={Link}
              >
                <i className="now-ui-icons arrows-1_cloud-download-93 mr-1"></i>
                Import donors
              </DropdownItem>
              <DropdownItem
                to="/liquidlove/delete-admin" tag={Link}
              >
                <i className="now-ui-icons ui-1_simple-remove mr-1"></i>
                Remove Admin
              </DropdownItem>                                                  
              <DropdownItem divider />
              <DropdownItem
                to="/liquidlove/signout" tag={Link}
              >
                <i className="now-ui-icons ui-1_lock-circle-open mr-1"></i>
                Logout
              </DropdownItem>                                                  
            </DropdownMenu>
          </UncontrolledDropdown>
        </li>
      </ul>      
    </div>
    <LLPushNotification />
    </>
  );
}

export default HomeNav;
